export default [
    {
        path: 'homework-template/create',
        name: 'homework-template:create',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "homework-template" */ '../../components/template/Form.vue'
            ),
        meta: {
            title: 'router.router_addHomeworkTemplate',
        },
        props: true,
    },
    {
        path: 'homework-template/:id/edit',
        name: 'homework-template:edit',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "homework-template" */ '../../components/template/Form.vue'
            ),
        meta: {
            title: 'router.router_editHomeworkTemplate',
        },
        props: true,
    },
    {
        path: 'lesson-conducting-template/create',
        name: 'lesson-conducting-template:create',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "lesson-conducting-template" */ '../../components/template/Form.vue'
            ),
        meta: {
            title: 'router.router_addHomeworkTemplate',
        },
        props: true,
    },
    {
        path: 'lesson-conducting-template/:id/edit',
        name: 'lesson-conducting-template:edit',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "lesson-conducting-template" */ '../../components/template/Form.vue'
            ),
        meta: {
            title: 'router.router_editHomeworkTemplate',
        },
        props: true,
    },
];
